import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  if (admin) return <Navigate to="/admin" replace />;
  const submit = async () => {
    setLoading(true);
    try { await login(f.email, f.password); nav("/admin"); }
    catch(e) { toast.error(formatApiError(e)); }
    finally { setLoading(false); }
  };
  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="admin-login-page">
      <h1 className="font-serif text-3xl text-emerald-900 mb-6">Espace administrateur</h1>
      <div className="space-y-3 p-6 bg-white border border-stone-200 rounded-xl">
        <input placeholder="Email" type="email" className="w-full border rounded-md px-3 py-2" value={f.email} onChange={e=>setF({...f,email:e.target.value})} data-testid="admin-email"/>
        <div className="relative">
          <input placeholder="Mot de passe" type={showPassword ? "text" : "password"} className="w-full border rounded-md px-3 py-2 pr-10" value={f.password} onChange={e=>setF({...f,password:e.target.value})} data-testid="admin-password"/>
          <button type="button" onClick={()=>setShowPassword(!showPassword)} aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"} data-testid="admin-password-toggle"
            className="absolute right-2 top-1/2 -translate-y-1/2 text-stone-500 hover:text-emerald-800 p-1">
            {showPassword ? <EyeOff size={18}/> : <Eye size={18}/>}
          </button>
        </div>
        <button disabled={loading} onClick={submit} data-testid="admin-login-btn"
          className="w-full bg-emerald-800 hover:bg-emerald-900 text-white py-2.5 rounded-md">
          {loading ? "Connexion…" : "Se connecter"}
        </button>
      </div>
    </div>
  );
}
